(function () {
  if(window.__luxGoogleContact)return;
  window.__luxGoogleContact=true;
  var ready=false;
  function allowed(){var p=window.Shopify&&Shopify.customerPrivacy;return ready&&p&&typeof p.analyticsProcessingAllowed==='function'&&p.analyticsProcessingAllowed();}
  function publish(method){if(!allowed()||!Shopify.analytics||typeof Shopify.analytics.publish!=='function')return false;Shopify.analytics.publish('luxmirrors:ga4_contact',{contact_method:method});return true;}
  document.addEventListener('click',function(e){
    var el=e.target instanceof Element?e.target:e.target&&e.target.parentElement;
    var a=el&&el.closest('a[href]');if(!a)return;
    var href=(a.getAttribute('href')||'').trim();var method;
    if(/^mailto:/i.test(href))method='email';
    else if(/^tel:/i.test(href))method='phone';
    else if(/^whatsapp:/i.test(href))method='whatsapp';
    else {try{var u=new URL(href,location.href);if(u.protocol==='https:'&&/^(wa\.me|api\.whatsapp\.com|www\.whatsapp\.com|web\.whatsapp\.com)$/.test(u.hostname))method='whatsapp';}catch(_){}}
    if(method)publish(method);
  },true);
  var key='lux_ga4_contact_pending';
  document.addEventListener('submit',function(e){
    if(e.target.matches&&e.target.matches('form.lux-contact-form')&&allowed()){
      try{sessionStorage.setItem(key,String(Date.now()));}catch(_){}
    }
  },true);
  function success(){
    if(!allowed()||!document.querySelector('[data-lux-contact-success]'))return;
    try{var pending=Number(sessionStorage.getItem(key));if(pending&&Date.now()-pending<3600000){if(publish('contact_form'))sessionStorage.removeItem(key);}}catch(_){}
  }
  document.addEventListener('visitorConsentCollected',success);
  if(window.Shopify&&typeof Shopify.loadFeatures==='function')Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){ready=!error;success();});
})();
